// The model is told the product is called "VoxEngine" (the platform is in
// stealth, so the real name never goes to a model). People must still see the
// real brand, so every place model-written text is rendered maps the
// placeholder back. Case-aware so headings, prose and possessives all land.
export const toDisplayBrand = (text) => {
  if (typeof text !== "string" || !text) return text;
  return text
    .replace(/VOXENGINE AI/g, "CROWDVOX AI")
    .replace(/VOXENGINE/g, "CROWDVOX")
    .replace(/VoxEngine AI/g, "CrowdVox AI")
    .replace(/VoxEngine/g, "CrowdVox")
    .replace(/voxengine ai/g, "crowdvox ai")
    .replace(/voxengine/g, "crowdvox");
};

export default toDisplayBrand;
